import React from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Label,
  FormGroup,
  Card,
  Button,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  FormText,
} from "reactstrap";
import { appHelpers, store } from "../../_helpers";

import NotificationSystem from "react-notification-system";
import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";
import { apiService, commonService } from "../../_services";

//Page content util
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import SelectListComponent from "../utils/selectList";
import PageEmptyContent from "../utils/page.empty-content";
// import SelectCreatableListComponent from "../utils/selectCreatableList";
import AirportTable from "./airport-table";
//Icons
import AddIcon from "react-icons/lib/md/library-add";
import AirportIcon from "react-icons/lib/md/flight-land";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class AirportViewContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      airports: [],
      modal: false,
      modalClass: "",
      //Airport form
      airportId: false,
      Name: "",
      Code: "",
      CountryCode: "",
      IsLocal: false,
      IsRegional: false,
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [], //Errors generated within the component form
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux

      //    Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
      },
      countries: [],
      searchAirportCode: "",
      searchCountryCode: "",
      createAirportEntityTypeId: null,
      editAirportEntityTypeId: null,
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { desAirports, countries, entities } = reduxState;
    const { dispatch } = this.props;
    // Fetch  Airports
    if (desAirports) {
      this.setState({
        airports: desAirports.Results,
      });
    } else {
      this.fetchAirports();
    }
    /*Check if countries exist in store*/
    if (countries) {
      this.setState({ countries: countries.Results });
    } else {
      this.fetchCountries();
    }

    /*Check if entity type exist in store */
    if (!entities) {
      dispatch(commonActions.getEntities());
    } else {
      this.setEntityTypes(entities);
    }
  }

  componentWillReceiveProps = function (nextProps) {
    const { alert } = nextProps;
    const { modal, entities } = nextProps;

    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        // this.setState({error: false, success: alert.message})
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass,
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass,
        });
        this.resetForm();
      }
    }

    if (entities) {
      this.setEntityTypes(entities);
    }
  };

  setEntityTypes = (entities) => {
    let createAirportEntityTypeId;
    let editAirportEntityTypeId;

    entities.forEach((entity) => {
      if (entity.EntityType === appConstants.APP_ENTITIES.CREATE_AIRPORT) {
        createAirportEntityTypeId = entity.EntityTypeId;
      } else if (
        entity.EntityType === appConstants.APP_ENTITIES.UPDATE_AIRPORT
      ) {
        editAirportEntityTypeId = entity.EntityTypeId;
      }
    });
    this.setState({ createAirportEntityTypeId, editAirportEntityTypeId });
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  handleSelectChange = (payload, attribute, stateAttribute) => {
    let currState = this.state;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[stateAttribute] = false;
    currState[stateAttribute] = payload ? payload[attribute] : ""; //Cater for setting up data and clearing data
    this.setState(currState);
  };

  handleCountryChange = (target) => {
    if (!(target === null && this.state.searchCountryCode === "")) {
      let countryCode = target ? target.Code : "";
      this.setState({
        contentError: false,
        searchAirportCode: "",
        searchCountryCode: countryCode,
      });
      let airportType = this.state.searchAirportCode;
      const { dispatch } = this.props;
      dispatch(apiActions.startRequest());
      let url =
        appConstants.PAS_URL +
        "/api/airport/search?countryCode=" +
        countryCode +
        "&isLocal=" +
        airportType;
      commonService
        .filterGetAirports(url)
        .then((res) => {
          this.setState({ airports: res.data.Results });
          dispatch(apiActions.endRequest());
        })
        .catch((err) => {
          // console.log(err.response);
          // console.log('Error:', err.request.status);
          // console.log(err.message);
          let errorMessage = appHelpers.interpretErrorResponse(err);
          this.notify(errorMessage, appConstants.NOTIFY_ERROR);
          dispatch(apiActions.endRequest());
        });
      /*apiService.get(url)
                .then((res) => {
                    this.setState({airports: res.data.Results });
                    dispatch(apiActions.endRequest());
                })
                .catch((error) => {
                    console.log(error);
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                });*/
    }
  };

  handleAirportCodeChange = (target) => {
    if (!(target === null && this.state.searchAirportCode === "")) {
      let airportCode = target ? target.Code : "";
      this.setState({ searchAirportCode: airportCode, searchCountryCode: "" });
      if (airportCode) {
        const { dispatch } = this.props;
        let url = appConstants.PAS_URL + "/api/Airport/Get?code=" + airportCode;
        apiService
          .get(url)
          .then((res) => {
            let record = res.data.Source;
            let _airports = [];
            if (record) {
              _airports.push(res.data.Source);
            }
            this.setState({ airports: _airports });
            dispatch(apiActions.endRequest());
          })
          .catch((error) => {
            let errorMessage = apiService.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            dispatch(apiActions.endRequest());
          });
      } else {
        this.fetchAirports();
      }
    }
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    if (this.state.Name === "") {
      _errs_["Name"] = "Please enter  airport name";
      formValid = false;
    }

    if (this.state.Code === "") {
      _errs_["Code"] = "Please enter airport code";
      formValid = false;
    }

    if (this.state.CountryCode === "") {
      _errs_["CountryCode"] = "Please select country";
      formValid = false;
    }
    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  onRemove = (notification) => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      airportId: false,
      Name: "",
      Code: "",
      CountryCode: "",
      IsLocal: false,
      IsRegional: false,
    });
    this.resetError();
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    this.resetError();
    if (this.validateInput()) {
      this.processSubmit();
    }
  };

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  processSubmit = () => {
    let { airportId } = this.state;
    const userRole = appHelpers.getActiveUser().AviRole;

    let payload = {
      Name: this.state.Name,
      Code: this.state.Code,
      CountryCode: this.state.CountryCode,
      IsLocal: this.state.IsLocal,
      IsRegional: this.state.IsRegional,
    };
    if (airportId) {
      payload.Id = airportId;
    }

    // dispatch(commonActions.manageAirport(payload))
    //     .then(res => {
    //         if (res.status === appConstants.SUCCESS_RESPONSE) {
    //             this.toggle(null, 'modalSlide');
    //             let msg = (payload.Id) ? 'Airport edited successfully' : 'Airport created successfully';
    //             this.notify(msg, appConstants.NOTIFY_SUCCESS);
    //             this.fetchAirports();
    //         }
    //         else if (res.status === appConstants.ERROR_RESPONSE) {
    //             dispatch(alertActions.error(res.response));
    //             dispatch(apiActions.endRequest());
    //         }
    //
    //     });

    if (userRole === appConstants.ROLES.SUPER_ADMIN) {
      this.createAirport(payload);
    } else {
      this.createMakerChecker(payload);
    }
  };

  createAirport = (payload) => {
    const { dispatch } = this.props;

    commonService.manageAirport(payload).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = payload.Id
          ? "Airport edited successfully"
          : "Airport created successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        this.fetchAirports();
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  createMakerChecker = (payload) => {
    const { dispatch } = this.props;
    const { authentication } = store.getState();
    let {
      airportId,
      createAirportEntityTypeId,
      editAirportEntityTypeId,
    } = this.state;

    /*Maker Checker */
    let payloadTemplate = {
      Name: this.state.Name,
      Code: this.state.Code,
      CountryCode: this.state.CountryCode,
      IsLocal: this.state.IsLocal ? "Yes" : "No",
      IsRegional: this.state.IsRegional ? "Yes" : "No",
    };

    let makerCheckerPayload = {
      AppId: appConstants.MAKER_CHECKER_APP_ID,
      Payload: JSON.stringify(payload),
      PayloadViewTemplate: JSON.stringify(payloadTemplate),
      URL: `${appConstants.PAS_URL}/api/airport/save`,
      EntityTypeId: createAirportEntityTypeId,
      CreatedBy: authentication.user.userName,
    };

    if (airportId) {
      makerCheckerPayload.EntityTypeId = editAirportEntityTypeId;
    }

    dispatch(apiActions.startRequest());
    commonService.createMakerChecker(makerCheckerPayload).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = payload.Id
          ? "Airport update sent successfully"
          : "Airport creation sent successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  fetchCountries = () => {
    const { dispatch } = this.props;
    dispatch(commonActions.getAllCountries())
      .then(() => {
        let { countries } = this.props;
        this.setState({ countries: countries.Results });
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(apiActions.endRequest());
      });
  };

  fetchAirports = () => {
    this.setState({ contentError: false });
    const { dispatch, desAirports } = this.props;

    if (!desAirports) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startRequest());
    }

    dispatch(commonActions.getDesAirports())
      .then(() => {
        let { desAirports } = this.props;
        this.setState({ airports: desAirports.Results });
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  passAirportsDetails = (airport) => {
    this.setState({
      airportId: airport.Id,
      Name: airport.Name ? airport.Name : "",
      Code: airport.Code ? airport.Code : "",
      CountryCode: airport.CountryCode ? airport.CountryCode : "",
      IsLocal: airport.IsLocal,
      IsRegional: airport.IsRegional,
    });
    this.toggle(null, "modalSlideIn");
  };
  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetForm();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };

  toggleCheckbox = (attribute) => {
    let currState = this.state;
    currState[attribute] = !currState[attribute];

    if (attribute === "IsLocal") {
      //if is IsRegional is selected first, once the user selects IsLocal, set IsRegional to false
      currState["IsRegional"] = false;
    }

    this.setState(currState);
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  render() {
    let modalResponse = this.renderPageResponse();
    const { requesting } = this.props;
    const { pageRequesting } = this.props;
    const {
      contentError,
      countries,
      airports,
      componentErrorMessages,
    } = this.state;
    let airportLength = airports.length;
    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                animated
                striped
                color="success"
                value={100}
                className="mb-2"
              />
            )}

            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody className="table-responsive">
                <div className="row">
                  <h6 className="mb-4 col-md-8 text-uppercase pull-left">
                    Airports Records
                    <FormText color="muted">
                      {airportLength > 0 && (
                        <div>
                          <AirportIcon size="18" color="#43a8df" />
                          &nbsp;
                          <span>
                            {airportLength}&nbsp;
                            {airportLength === 1
                              ? "airport matched"
                              : "airports matched"}
                          </span>
                        </div>
                      )}
                    </FormText>
                  </h6>
                  <div className="mb-4 col-md-4 text-right">
                    <Button
                      className="btn-avi-primary"
                      onClick={(e) => this.toggle(e, "modalSlideIn")}
                    >
                      <AddIcon color="#ffffff" size="18" />
                      &nbsp;Create Airport
                    </Button>{" "}
                  </div>
                </div>

                <div>
                  <Form onSubmit={this.fetchAirports}>
                    <Row>
                      <Col sm="4">
                        <FormGroup className="mb-4">
                          <SelectListComponent
                            placeholder={"Select country..."}
                            data={countries}
                            valueKey="Code"
                            textField="Name"
                            selectValue={this.state.searchCountryCode}
                            onValueChange={(payload) =>
                              this.handleCountryChange(payload)
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="4">
                        <FormGroup className="mb-4">
                          <SelectListComponent
                            placeholder={"Type airport code..."}
                            data={airports}
                            valueKey="Code"
                            textField="Code"
                            selectValue={this.state.searchAirportCode}
                            onValueChange={(payload) =>
                              this.handleAirportCodeChange(payload)
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </div>

                {!pageRequesting && airportLength > 0 && (
                  <AirportTable
                    data={airports}
                    editCallback={this.passAirportsDetails}
                  />
                )}

                {!pageRequesting && airportLength === 0 && (
                  <PageEmptyContent message="No airport match your search!" />
                )}

                <Modal
                  isOpen={this.state.modal}
                  toggle={this.toggle}
                  className={this.state.modalClass}
                >
                  <ModalHeader toggle={this.toggle}>Airports</ModalHeader>
                  <Form onSubmit={this.handleSubmit}>
                    <ModalBody>
                      {modalResponse}

                      <FormGroup
                        className={
                          "mb-4 " +
                          (this.state.componentErrorMessages.Name
                            ? "has-danger"
                            : "")
                        }
                      >
                        <Label>Airport Name</Label>
                        <Input
                          type="text"
                          placeholder=""
                          value={this.state.Name}
                          onChange={(event) => this.handleChange(event, "Name")}
                        />
                        {componentErrorMessages.Name && (
                          <FormText color="danger">
                            {" "}
                            {componentErrorMessages.Name}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup
                        className={
                          "mb-4 " +
                          (this.state.componentErrorMessages.Code
                            ? "has-danger"
                            : "")
                        }
                      >
                        <Label>Airport Code</Label>
                        <Input
                          type="text"
                          placeholder=""
                          value={this.state.Code}
                          onChange={(event) => this.handleChange(event, "Code")}
                        />
                        {componentErrorMessages.Code && (
                          <FormText color="danger">
                            {" "}
                            {componentErrorMessages.Code}
                          </FormText>
                        )}
                      </FormGroup>

                      <FormGroup
                        className={
                          "mb-4 " +
                          (this.state.componentErrorMessages.CountryCode
                            ? "has-danger"
                            : "")
                        }
                      >
                        <Label for="countrySelect">Country </Label>
                        <SelectListComponent
                          data={countries}
                          valueKey="Code"
                          textField="Name"
                          selectValue={this.state.CountryCode}
                          onValueChange={(payload) =>
                            this.handleSelectChange(
                              payload,
                              "Code",
                              "CountryCode"
                            )
                          }
                        />
                        {componentErrorMessages.CountryCode && (
                          <FormText color="danger">
                            {" "}
                            {componentErrorMessages.CountryCode}
                          </FormText>
                        )}
                      </FormGroup>
                      <Row form>
                        <Col>
                          <FormGroup
                            className={
                              "mb-4 " +
                              (this.state.componentErrorMessages.IsLocal
                                ? "has-danger"
                                : "")
                            }
                          >
                            <input
                              type="checkbox"
                              className="checkbox-control"
                              name="disabled"
                              checked={this.state.IsLocal}
                              onChange={() => this.toggleCheckbox("IsLocal")}
                            />
                            <span className="checkbox-label">
                              &nbsp;Is local?
                            </span>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup
                            className={
                              "mb-4 " +
                              (this.state.componentErrorMessages.IsRegional
                                ? "has-danger"
                                : "")
                            }
                          >
                            <input
                              type="checkbox"
                              className="checkbox-control"
                              name="disabled"
                              checked={this.state.IsRegional}
                              onChange={() => this.toggleCheckbox("IsRegional")}
                              disabled={this.state.IsLocal}
                            />
                            <span className="checkbox-label">
                              &nbsp;Is Regional?
                            </span>
                          </FormGroup>
                        </Col>
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn-avi-primary" disabled={requesting}>
                        {" "}
                        Proceed{" "}
                      </Button>{" "}
                      <Button color="secondary" onClick={this.toggle}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Form>
                  {requesting && <div className={"loading-dot active"} />}
                </Modal>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { requesting, pageRequesting } = state.api;
  const { alert, modal, desAirports, countries, entities } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    modal,
    alert,
    desAirports,
    countries,
    entities,
  };
}
export default connect(mapStateToProps)(AirportViewContent);



// WEBPACK FOOTER //
// ./src/views/airport/view-content.js